import { Box, styled, Typography } from '@mui/material'
import QuantityInput from '@src/components/share/generic/QuantityInput'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

const Container = styled(Box)`
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const Label = styled(Typography)`
  color: white;
  flex: 1;
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: 300;
  line-height: 14px;
`

const StyledInput = styled(QuantityInput)`
  flex: 1;
  max-width: 168px;
`

const TradeQuanatitySection: FC<Props> = (props: Props) => {
  const {
    allowInput = true,
    className,
    quantity,
    totalQuantity,
    onChange
  } = props

  const { t } = useTranslation()

  return (
    <Container className={className}>
      <Label className='Custom-Label'>{t('dialog.quantity_label')}</Label>
      <StyledInput
        allowInput={allowInput}
        className='Custom-Quantity-Input'
        quantifier=''
        total={totalQuantity}
        value={quantity}
        onChange={onChange}
      />
    </Container>
  )
}

type Props = {
  allowInput?: boolean
  className?: string
  quantity: number
  totalQuantity: number
  onChange: (quantity: number) => void
}

export default TradeQuanatitySection
